import React from 'react'
import FormQuestion from '../../components/private/FormQuestion'

const CreateQuestion = () => {
    return (
        <div>
            <FormQuestion/>
        </div>
    )
}

export default CreateQuestion
